import React from "react";

const SolveButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-40 h-8 bg-zinc-800 rounded-full flex items-center justify-center 
                 text-zinc-300 text-xs font-medium font-inter tracking-wide 
                 transition-all duration-300 ease-in-out 
                 hover:bg-zinc-700 hover:text-white hover:tracking-wider 
                 active:scale-95 shadow-md hover:shadow-lg"
    >
      Solve
    </button>
  );
};

export default SolveButton;
